"use client";

import { CloseIcon } from "../../../../dx/ui/icons";

type CheckoutHeaderProps = {
  /** dialog の aria-labelledby が指す id。可視タイトル h2 に付ける */
  titleId: string;
  /** 閉じるボタン押下時 */
  onRequestClose: () => void;
  messages: { title: string; closeLabel: string };
};

/**
 * チェックアウト日選択のヘッダー (可視タイトル + 閉じるボタン)。
 * h2 に titleId を付与することで、各シェルの aria-labelledby={titleId} と対応する。
 */
export function CheckoutHeader({
  titleId,
  onRequestClose,
  messages,
}: CheckoutHeaderProps) {
  return (
    <div className="flex shrink-0 items-center justify-between p-[16px]">
      <h2
        id={titleId}
        className="font-notojp text-dx-text-default text-[16px] leading-[28px] font-bold"
      >
        {messages.title}
      </h2>
      <button
        data-analytics-id="reservation_calendar_closed_checkout_drawer"
        type="button"
        onClick={onRequestClose}
        className="bg-dx-surface-base flex size-[36px] shrink-0 items-center justify-center rounded-full"
        aria-label={messages.closeLabel}
      >
        <CloseIcon className="text-dx-text-default size-[24px]" />
      </button>
    </div>
  );
}
